/**
 * ThunderLabs Landing Page Entry Point
 * 
 * This is a standalone entry point for the public landing page.
 * It mounts the Vue LandingPage component without requiring authentication.
 */

import { createApp } from 'vue'
import PrimeVue from 'primevue/config'

// Import PrimeVue components used in landing page
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import ProgressBar from 'primevue/progressbar'
import Card from 'primevue/card'

// Import styles
import 'primeicons/primeicons.css'

// Import ThunderLabs Design System
import '../src/design-system/_components.scss'

// Import Landing Page component
import LandingPage from '../src/components/marketing/LandingPage.vue'

// Create and mount the app
const app = createApp(LandingPage)

// Configure PrimeVue with unstyled mode for custom ThunderLabs styling
app.use(PrimeVue, {
  unstyled: false,
  ripple: true
})

// Register global components
app.component('Button', Button)
app.component('InputText', InputText)
app.component('ProgressBar', ProgressBar)
app.component('Card', Card)

// Mount to the landing app container
app.mount('#landing-app')

// Hide loading spinner once mounted
const loadingElement = document.getElementById('landing-loading')
if (loadingElement) {
  loadingElement.style.display = 'none'
}

console.log('🚀 ThunderLabs Landing Page mounted successfully')
